import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Updates header color swatch markup from the section HTML when the variant changes.
 *
 * @extends {Component}
 */
class HeaderColorSwatchBlock extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /** @param {Event} event */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBlock = event.detail.data.html.querySelector(
      `header-color-swatch-block[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newBlock) return;

    this.innerHTML = newBlock.innerHTML;
  };
}

if (!customElements.get('header-color-swatch-block')) {
  customElements.define('header-color-swatch-block', HeaderColorSwatchBlock);
}
